/** FAQPage da home: só pode existir na rota "/" para não duplicar FAQPage nas demais páginas. */
export const FAQ_JSONLD = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Como funciona a automação no WhatsApp e Instagram com IA?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "A OP2P reúne conversas do WhatsApp e Instagram no CRM. Agentes de IA respondem, qualificam contatos, registram o histórico e encaminham oportunidades para a equipe.",
      },
    },
    {
      "@type": "Question",
      name: "É seguro utilizar um sistema de automação com IA no WhatsApp e no Instagram?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sim, os sistemas de automação com tecnologia de IA são desenvolvidos com medidas de segurança robustas para proteger os dados dos usuários, seguindo as diretrizes de privacidade do WhatsApp e do Instagram e regulamentações de proteção de dados.",
      },
    },
    {
      "@type": "Question",
      name: "O que é a OP2P?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "OP2P é um CRM inteligente que reúne WhatsApp e Instagram. Seus Agentes de IA atendem, qualificam e fazem follow-up, enquanto o CRM organiza o histórico e movimenta as oportunidades no funil.",
      },
    },
  ],
});
